import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import AsyncPrepayClaimsPage from './containers/Claims/PrepayClaimsPage/Loadable';
import AsyncAppealsPage from './containers/Appeals/Loadable';
import AsyncInquiriesPage from './containers/Inquiries/Loadable';
import AsyncMyRecentActivitiesPage from './containers/MyRecentActivities/Loadable';
import AsyncAcknowledgementPage from './containers/AcknowledgementPage/Loadable';
import AsyncDocumentsPage from './containers/Documents/Loadable';
import AsyncSupportPage from './containers/HelpAndSupport/Loadable';
import AsyncInvoicingPage from './containers/Invoicing/Loadable';
import AsyncCreateInvoicesPage from './containers/Invoicing/CreateInvoicesPage/Loadable';
import AsyncInvoiceSearchPage from './containers/Invoicing/InvoiceSearchPage/Loadable';
import AsyncPrivacyNoticePage from './containers/PrivacySecurity/PrivacyNotice/Loadable';
import AsyncTermsOfUsePage from './containers/PrivacySecurity/TermsOfUse/Loadable';
import AsyncRulesPage from './containers/RuleSpec/Rules/Loadable';
import AsyncReasonCodesPage from './containers/RuleSpec/ReasonCodes/Loadable';
import AsyncDocumentReferencesPage from './containers/RuleSpec/DocumentReferences/Loadable';
import AsyncClientsPage from './containers/ClientManagement/Clients/Loadable';
import AsyncAppealResponsesPage from './containers/AppealResponses/Loadable';
import AsyncActivityLogPage from './containers/ActivityLog/Loadable';
import AsyncAuthTest from './containers/AuthTest/Loadable';
import NotAuthorized from './containers/Security/NotAuthorized';
import Logout from './containers/Security/Logout';
import NotFound from 'containers/NotFound';
import {
  AppealsRoute,
  BaseRoute,
  ClaimsPrepayRoute,
  InquiriesRoute,
  MyRecentActivitiesRoute,
  DocumentsRoute,
  InvoicingRoute,
  CreateInvoicesRoute,
  InvoiceSearchRoute,
  HelpandSupportRoute,
  PrivacyNoticeRoute,
  TermsOfUseRoute,
  RulesRoute,
  ReasonCodesRoute,
  ClientsRoute,
  AppealResponsesRoute,
  DocumentReferencesRoute,
  ActivityLogRoute,
} from 'constants/routes';
import AuthModal from 'containers/Security/AuthModal';
import PrivateRoute from 'containers/Security/PrivateRoute';
import { WithRoleAndPermission } from 'components/Hoc/WithRoleAndPermission';
import { PERMISSIONS, ROLES } from 'containers/Security/modules/enums';

export const history = createBrowserHistory();
/**
 * This component can be used to show different components when user
 * visits to different paths. We use connected react router which stores the current path
 * and other route parameters to the redux store.
 *
 */

const routes = [
  {
    path: BaseRoute,
    component: AsyncAcknowledgementPage,
    exact: true,
  },
  {
    path: ClaimsPrepayRoute,
    component: WithRoleAndPermission(PERMISSIONS.CLAIM_SEARCH_VIEW_READ)(AsyncPrepayClaimsPage),
  },
  // {
  //   path: ClaimsPaidRoute,
  //   component: AsyncPaidClaimsPage,
  // },
  {
    path: AppealsRoute,
    component: WithRoleAndPermission(PERMISSIONS.CLAIM_SEARCH_VIEW_READ)(AsyncAppealsPage),
  },
  {
    path: InquiriesRoute,
    component: WithRoleAndPermission(PERMISSIONS.CLAIM_SEARCH_VIEW_READ)(AsyncInquiriesPage),
  },
  {
    path: MyRecentActivitiesRoute,
    component: WithRoleAndPermission(PERMISSIONS.ACTIVITY_LOG_CREATE)(AsyncMyRecentActivitiesPage),
  },
  {
    path: DocumentsRoute,
    component: WithRoleAndPermission(PERMISSIONS.DOCUMENT_READ)(AsyncDocumentsPage),
  },
  {
    path: CreateInvoicesRoute,
    component: WithRoleAndPermission(PERMISSIONS.INVOICING_CREATE)(AsyncCreateInvoicesPage),
  },
  {
    path: InvoiceSearchRoute,
    component: WithRoleAndPermission(PERMISSIONS.INVOICING_READ)(AsyncInvoiceSearchPage),
  },
  {
    path: InvoicingRoute,
    component: WithRoleAndPermission(PERMISSIONS.INVOICING_READ)(AsyncInvoicingPage),
  },
  {
    path: RulesRoute,
    component: WithRoleAndPermission(PERMISSIONS.RULE_SPEC_READ)(AsyncRulesPage),
  },
  {
    path: ReasonCodesRoute,
    component: WithRoleAndPermission(PERMISSIONS.RULE_SPEC_READ)(AsyncReasonCodesPage),
  },
  {
    path: DocumentReferencesRoute,
    component: WithRoleAndPermission(PERMISSIONS.RULE_SPEC_READ)(AsyncDocumentReferencesPage),
  },
  {
    path: ClientsRoute,
    component: WithRoleAndPermission(PERMISSIONS.CLIENT_ADMIN_READ)(AsyncClientsPage),
  },
  {
    path: AppealResponsesRoute,
    component: WithRoleAndPermission(PERMISSIONS.APPEAL_RESPONSE_READ)(AsyncAppealResponsesPage),
  },
  {
    path: ActivityLogRoute,
    component: WithRoleAndPermission(PERMISSIONS.ACTIVITY_LOG_READ)(AsyncActivityLogPage),
  },
  {
    path: HelpandSupportRoute,
    component: WithRoleAndPermission(PERMISSIONS.HELP_AND_SUPPORT_READ)(AsyncSupportPage),
  },
  {
    path: `${BaseRoute}/testauth`,
    component: WithRoleAndPermission('', ROLES.ADMIN_USER)(AsyncAuthTest),
    exact: true,
  },
];

const ApplicationRoutes = () => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route path={`${BaseRoute}/auth`} component={AuthModal} />
        <Route path={`${BaseRoute}/silent-refresh`} component={AuthModal} />
        {routes.map((x) => (
          <PrivateRoute key={x.path} {...x} />
        ))}
        <Route path={`${BaseRoute}/login`} exact component={NotAuthorized} />
        <Route path={`${BaseRoute}/logout`} exact component={Logout} />
        <Route path={PrivacyNoticeRoute} exact component={AsyncPrivacyNoticePage} />
        <Route path={TermsOfUseRoute} exact component={AsyncTermsOfUsePage} />
        <Route path="/*" exact component={NotFound} />
      </Switch>
    </ConnectedRouter>
  );
};

export default ApplicationRoutes;
